export default "__VITE_ASSET__DxZaN3eA__"